export default __webpack_public_path__ + "static/media/Resume of Yeasin Hossen.7806b8f0.pdf";